import styled from "styled-components";

export const CardBannerWraper = styled.div`
  width: 100%;
  height: 180px;
  padding: 2.3px;
  border-radius: 13.36px;
  overflow: hidden;
  background-color: white;
  padding: 34px 40px;
  @media screen and (max-width: 1440px) {
    height: 110px;
    padding: 16px 30px;
    border-radius: 10px;
  }
  &.active {
    background-color: #000;
    .card-banner-icon,
    .card-banner-title,
    .card-banner-balance {
      color: #fff;
      svg {
        path {
          fill: white;
        }
      }
    }
    .card-banner-divide {
      background-color: #ffffff66;
    }
  }
  @media screen and (min-width: 1367px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) and (max-width: 1366px) {
    width: 100%;
    height: 115px;
    padding: 20px 14px 20px 14px;
  }
  @media screen and (max-width: 1024px) {
    width: 100%;
    max-width: 300px;
    height: 100px;
    border-radius: 10px;
    padding: 20px 14px 20px 14px;
  }
`;
export const CardBannerIcon = styled.div`
  width: 62px;
  height: 69px;
   @media screen and (max-width: 1440px) {
    width: 51px;
    height: 56px;
  }
  svg {
    width: 100%;
    height: 100%;
  }
`;
export const CardBannerDivide = styled.div`
  width: 1px;
  height: 100%;
  background: #0000001a;
  margin-left: 26px;
  margin-right: 26px;
  @media screen and (max-width: 1440px) {
    margin-left: 21px;
    margin-right: 21px;
  }
  @media screen and (max-width: 1024px) {
    height: 61px;
    margin-left: 12px;
    margin-right: 12px;
  }
`;
export const CardBanner = styled.div`
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border-radius: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const CardBannerTitle = styled.div`
  color: #101828;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  @media screen and (max-width: 1440px) {
    font-size: 16px;
    line-height: 19px;
  }
  @media screen and (max-width: 1024px) {
    font-size: 14px;
    font-weight: 500;
  }
`;
export const CardBannerNumber = styled.div`
  color: #101828;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
  height: 35px;
  @media screen and (max-width: 1440px) {
    font-size: 28px;
    line-height: 34.74px;
    height: 35px;
  }
  @media screen and (max-width: 1024px) {
    font-size: 20px;
  }
`;

export const CardBannerPeriod = styled.div`
  color: ${(props) => props.colorPeriod || "#40b877"};
  font-family: Lato;
  font-size: 12.825px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
  @media screen and (max-width: 1024px) {
    font-size: 10px;
  }
`;
